import { Box, CheckBox, SortDirection, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ProjectsToImport } from 'modules/project_management/lib/types'

interface HeaderProps {
  attribute: string
  direction: SortDirection
  onClickAll: () => void
  onSort: (attribute: string, direction: SortDirection) => void
  projectsList: ProjectsToImport[]
  selected: ProjectsToImport[]
  tabId: string
}

const Header = ({
  attribute,
  direction,
  onClickAll,
  onSort,
  projectsList,
  selected,
  tabId,
}: HeaderProps) => {
  const headerNames = [
    {
      name: i18n.t('project_management.imports.table.headers.type'),
      colSpan: 2,
      attribute: 'type',
    },
    {
      name: i18n.t('project_management.imports.table.headers.project_name'),
      colSpan: 2,
      attribute: 'project_name',
    },
    {
      name: i18n.t('project_management.imports.table.headers.project_billable'),
      colSpan: 2,
      attribute: 'project_billable',
    },
    {
      name: i18n.t('project_management.imports.table.headers.project_legal_entity'),
      colSpan: 2,
      attribute: 'project_legal_entity',
    },
    {
      name: i18n.t('project_management.imports.table.headers.project_code'),
      colSpan: 2,
      attribute: 'project_code',
    },
    {
      name: i18n.t('project_management.imports.table.headers.project_description'),
      colSpan: 2,
      attribute: 'project_description',
    },
    {
      name: i18n.t('project_management.imports.table.headers.start_date'),
      colSpan: 2,
      attribute: 'project_start_date',
    },
    {
      name: i18n.t('project_management.imports.table.headers.due_date'),
      colSpan: 2,
      attribute: 'project_due_date',
    },
    {
      name: i18n.t('project_management.imports.table.headers.project_fixed_cost'),
      colSpan: 2,
      attribute: 'project_fixed_cost',
    },
    {
      name: i18n.t('project_management.imports.table.headers.planned_hours'),
      colSpan: 2,
      attribute: 'planned_hours',
    },
    {
      name: i18n.t('project_management.imports.table.headers.planned_cost'),
      colSpan: 2,
      attribute: 'planned_cost',
    },
    {
      name: i18n.t('project_management.imports.table.headers.planned_income'),
      colSpan: 2,
      attribute: 'planned_income',
    },
    {
      name: i18n.t('project_management.imports.table.headers.subprojects'),
      colSpan: 2,
      attribute: 'subproject_names',
    },
    {
      name: i18n.t('project_management.imports.table.headers.status'),
      colSpan: 2,
      attribute: 'project_status',
    },
  ]

  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell
          width={50}
          left={
            <CheckBox
              checked={selected?.length === projectsList?.length}
              disabled={tabId === 'errored'}
              onClick={onClickAll}
            />
          }
        />
        {headerNames.map((headerName) => (
          <Table.SortableHeadCell
            colSpan={headerName.colSpan}
            key={headerName.name}
            attribute={headerName.attribute}
            onSort={onSort}
            sortAttribute={attribute}
            sortDirection={direction}
          >
            <Box inline width={'fit-content'} style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
              {headerName.name}
            </Box>
          </Table.SortableHeadCell>
        ))}
      </Table.Row>
    </Table.Head>
  )
}

export default Header
